import { render, staticRenderFns } from "./CellStatusDropdownPerfAds.vue?vue&type=template&id=5384832d&scoped=true&"
import script from "./CellStatusDropdownPerfAds.vue?vue&type=script&lang=js&"
export * from "./CellStatusDropdownPerfAds.vue?vue&type=script&lang=js&"
import style0 from "./CellStatusDropdownPerfAds.vue?vue&type=style&index=0&id=5384832d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5384832d",
  null
  
)

export default component.exports